import {RouteLang} from "./enum/route-lang.enum";
import type {MenuItemRoute} from "~~/route/interface/menu-item-route.interface";

export const menuMainItems: MenuItemRoute[] = [
    {
        identifier: 'home',
        path: {
            [RouteLang.FR]: '/',
        },
        level1: true,
    },
    {
        identifier: 'soins',
        path: {
            [RouteLang.FR]: '/#soins',
        },
        level1: true,
    },
    {
        identifier: 'qui-suis-je',
        path: {
            [RouteLang.FR]: '/qui-suis-je',
        },
        level1: true,
    },
    {
        identifier: 'gift-card',
        path: {
            [RouteLang.FR]: '/bon-cadeau',
        },
        level1: true,
    },
    {
        identifier: 'booking',
        url: 'https://booking.clemkerato.be/soins',
        level1: true,
    },
    {
        identifier: 'gift-card-billing-info-form',
        path: {
            [RouteLang.FR]: '/bon-cadeau/facturation',
        }
    },
    {
        identifier: 'gift-card-confirmation',
        path: {
            [RouteLang.FR]: '/bon-cadeau/retour',
        }
    }
];